import React, { Fragment, useState } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader,  Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Breadcrumbs, UL, LI, H4, H5, H6 } from "../../../../AbstractElements";
import ExpandableContent from "../../../Common/ExpandableContent/ExpandableContent";
import VideoPlayer from "../../../Common/VideoPlayer/VideoPlayer";
import { useTranslation } from 'react-i18next';
import "../../../../Components/Presentation/EOR/WAG.css";

import ReactApexChart from 'react-apexcharts';
import ValuableCustomer from '../../../Dashboard/Ecommerce/ValuableCustomer';
//import { RadialProgressWidgetData } from '../../../Data/Crypto';

import UpcomingSchedule from '../../../Dashboard/OnlineCourse/UpcomingSchedule';
import CryptoAnnotations from '../../../Widgets/Chart/CryptoAnnotations';
import { OptionsOverView, OptionsOverViewBarChart, MonthlyProfitsChartData } from '../../../../Data/Ecommerce/Chart';
import RadialProgressWidget from '../../../Common/CommonWidgets/RadialProgressWidget';

import AllCards from '../../../Application/Users/UsersCards/AllCards';
import CardProfileUnique from '../../../Application/Users/CardProfileUnique/CardProfileUnique';

const WAGBassin = () => {
  const [activeTab, setActiveTab] = useState('1');
  const { t } = useTranslation();

  const RadialProgressWidgetData = [
    {
      title: t('Average_Daily_Sales'),
      average: t('Average_Daily_Sales_Value'),
      gros: 5.7,
      color: "primary",
      subTitle: t('Average_Daily_Sales_Subtitle'),
      chart: {
        series: [70],
        color: "var(--theme-default)",
      },
    },
    {
      title: t('Average_Daily_Profitability'),
      average: t('Average_Daily_Profitability_Value'),
      gros: 5.7,
      color: "secondary",
      subTitle: t('Average_Daily_Profitability_Subtitle'),
      chart: {
        series: [80],
        color: "var(--theme-secondary)",
      },
    }
  ];

  // Dados customizados para o componente ValuableCustomer
  const clientesParceirosData = [
    {
      name: "Rejane Rocha",
      email: "Secretária-executiva do Centro Brasil-China",
      image: "WAG_1.jpg"
    },
    {
      name: "João P. Bassin",
      email: "Professor Adjunto da UFRJ",
      image: "WAG_2.jpg"
    },
    {
      name: "Argimiro R. Secchi",
      email: "Doutorado em Engenharia Química",
      image: "WAG_3.jpg"
    },
    {
      name: "Márcio D'Agosto",
      email: "Doutorado em Engenharia de Transportes pela COPPE/UFRJ",
      image: "WAG_4.jpg"
    }
  ];

  // Dados customizados para o componente CryptoAnnotations
  const dadosEmissoesCO2 = {
    series: [
      {
        data: [8107, 8300, 8260, 8400, 8350, 8500, 8350],
      },
    ],
    options: {
      chart: {
        height: 400,
        type: 'line',
        toolbar: {
          show: false,
        },
      },
      annotations: {
        yaxis: [
          {
            y: 8200,
            y2: 8400,
            borderColor: '#f8d62b',
            fillColor: '#f8d62b',
            opacity: 0.1,
            label: {
              borderColor: '#f8d62b',
              offsetX: -30,
              style: {
                fontSize: '10px',
                color: '#fff',
                background: '#f8d62b',
              },
              text: 'Y-axis range',
            },
          },
        ],
        xaxis: [
          {
            x: new Date('15 Nov 2017').getTime(),
            strokeDashArray: 0,
            borderColor: '#7366ff',
            label: {
              borderColor: '#7366ff',
              offsetY: 20,
              style: {
                color: '#fff',
                background: '#7366ff',
              },
              text: 'Anno Test',
            },
          },
          {
            x: new Date('17 Nov 2017').getTime(),
            x2: new Date('18 Nov 2017').getTime(),
            fillColor: '#51bb25',
            opacity: 0.1,
            label: {
              borderColor: '##51bb25',
              style: {
                fontSize: '10px',
                color: '#fff',
                background: '#51bb25',
              },
              offsetY: 20,
              text: 'X-axis range',
            },
          },
        ],
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 3,
        curve: 'smooth',
      },
      grid: {
        padding: {
          right: 30,
          left: 20,
        },
      },
      title: {
        text: 'Line with Annotations',
        align: 'left',
        style: {
          fontSize: '18px',
          fontFamily: 'Rubik, sans-serif',
          fontWeight: 500,
        },
      },
      colors: ['#f73164'],
      labels: ['13 Nov 2017', '14 Nov 2017', '15 Nov 2017', '16 Nov 2017', '17 Nov 2017', '20 Nov 2017', '21 Nov 2017'],
      xaxis: {
        type: 'datetime',
      },
      responsive: [
        {
          breakpoint: 576,
          options: {
            title: {
              style: {
                fontSize: '16px',
              },
            },
          },
        },
      ],
    },
  };
  
  // Dados customizados para o componente UpcomingSchedule
  const cronogramaAtividadesData = [
    {
      title: t('Industrial_Emissions_Monitoring'),
      image: "4.jpg",
      icon: "flask",
      icon2: "clock",
      date: "3 de Janeiro de 2025",
      date2: "09.00 - 12.00",
      color: "primary",
    },
    {
      title: t('Workshop_New_Technologies'),
      image: "2.jpg",
      icon: "cog",
      icon2: "clock",
      date: "10 de Fevereiro de 2025",
      date2: "14.00 - 17.00",
      color: "success",
    }
  ];

  const menuOptions = [
    {
      id: '1',
      title: t('Overview'),
      icon: 'home'
    },
    {
      id: '2',
      title: t('Process'),
      icon: 'bullseye'
    },
    {
      id: '3',
      title: t('Applications_menu'),
      icon: 'money'
    },
    {
      id: '4',
      title: t('Benefits'),
      icon: 'users'
    },
    {
      id: '5',
      title: t('Files'),
      icon: 'paperclip'
    },
    {
      id: '6',
      title: t('Activities'),
      icon: 'tachometer'
    }
  ];

  const renderContent = (title) => {
    switch (title) {
      case t('Overview'):
        return (
          <div className="wag-dashboard">
            {/* Primeira linha - Conteúdo principal e sidebar */}
            <Row className="mb-4">
              <Col xs={12} lg={12} xl={8} className="mb-xl-4 mb-xl-0">
                <Card className="main-summary">
                  <CardHeader className="card-no-border"> 
                    <div className="common-space"> 
                      <div className="left-header-content">
                        <h5>{t('Overview_Title')}</h5>  
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0"> 
                    
                    <Row className="g-3">
                      <Col xs={12}>
                        <VideoPlayer
                          videoSrc={require("../../../../assets/video/bassin_edit_alta.mp4")}
                          posterSrc={require("../../../../assets/images/WAG/WAG_BASSIN.png")}
                          width="100%"
                          height="380px"
                          controls={true}
                          loop={true}
                          className="wag-video-player"
                        />
                      </Col>
                    </Row>
                  <Row className="g-3 p-2">
                    
                    
                    <li style={{listStyleType: "none"}}> 
                      <ul className="common-space p-x-2">
                        <li> 
                          <ul> 
                            <li> 
                              <p className="mb-1">{t('Creation_Date')} </p><span>14/03/2024</span>
                            </li>
                            <br/>
                            <li> 
                              <p className="mb-1">{t('Due_Date')}</p><span>30/04/2024</span>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <ul>
                            <li> 
                              <p className="mb-1">{t('Priority')}</p>
                              <span className="badge badge-light-primary">{t('High')}</span>
                            </li>
                            <br/>
                            <li> 
                              <p className="mb-1">{t('Status')}</p>
                              <span className="badge badge-light-success">{t('In_Progress')}</span>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p className="p-t-10 mb-2">{t('Resource')}</p>
                          <div className="attachment-file common-flex">
                            <div className="common-flex align-items-center">
                              <img className="img-fluid" src={require("../../../../assets/icons/pdf.png")} alt="pdf" />
                              <div className="d-block"> 
                                <p className="mb-0">Relatório Técnico "Carbon Flow — Projeto WebFlow"</p>
                                <p className="c-o-light">678 KB</p>
                              </div>
                            </div>
                              <a href="../assets/pug/pages/template/text_file.pdf" download=""> 
                                <i className="fa fa-solid fa-download f-light"></i>
                              </a>
                          </div>
                        </li>
                      </ul>
                      </li>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              
              <Col xs={12} lg={12} xl={4}>
                  <Row>
                    <CardProfileUnique 
                      id={1}
                      avatar="dashboard/user/WAG_2_CARD.jpg"
                      icon="profile-check"
                      name="João Paulo Bassin"
                      email="@joao.bassin"
                      totalPost="1,908"
                      follower="34"
                      following="897"
                    />
                    {/*{
                    <Card className="social-profile">
                    <CardBody>
                      <div className="social-img-wrap">
                        <div className="social-img">
                          <img src="https://cdn.britannica.com/89/164789-050-D6B5E2C7/Barack-Obama-2012.jpg?w=300&h=300&c=crop" alt="profile" className="media"/>
                        </div>
                        <div className="edit-icon d-none">
                          <svg>
                            <use href="/cuba-context/svg/sprite.svg#profile-check"></use>
                          </svg>
                        </div>
                      </div>
                      <div className="social-details">
                        <h5 className="mb-1"><a href="/cuba-context/app/social-app">Dra. Helena Duarte</a></h5>
                        <span className="f-light">@helena.duarte</span>
                        <ul className="d-none d-flex justify-content-center card-social list-group list-group-horizontal">
                          <li className="list-group-item"> <a href="https://www.facebook.com/" target="_blank" rel="noreferrer"><i className="fa fa-facebook"></i></a></li>
                          <li className="list-group-item"> <a href="https://accounts.google.com/" target="_blank" rel="noreferrer"><i className="fa fa-google-plus"></i></a></li>
                          <li className="list-group-item"> <a href="https://twitter.com/" target="_blank" rel="noreferrer"><i className="fa fa-twitter"></i></a></li>
                          <li className="list-group-item"> <a href="https://www.instagram.com/" target="_blank" rel="noreferrer"><i className="fa fa-instagram"></i></a></li>
                          <li className="list-group-item"> <a href="https://rss.app/" target="_blank" rel="noreferrer"><i className="fa fa-rss"></i></a></li>
                        </ul>
                        <ul className="social-follow list-group">
                          <li className="list-group-item"> <h5 className="mb-0">1,908</h5><span className="f-light">Artigos</span></li>
                          <li className="list-group-item"> <h5 className="mb-0">34</h5>
                              Apresentações
                            </li>
                          <li className="list-group-item"> <h5 className="mb-0">897</h5> <span className="f-light">Avaliações</span></li>
                        </ul>
                      </div>
                    </CardBody>
                    </Card>
                    */}
                  <ValuableCustomer title={t('Professors_Participants')} data={clientesParceirosData} />
                
                </Row>
               
              </Col>

              <Col xs={12} lg={12} xl={12} className="mb-4 mb-lg-0">
                <Card className="main-summary">
                  <CardHeader className="card-no-border"> 
                    <div className="common-space"> 
                      <div className="left-header-content">
                        <h5>{t('CO2_Title')}</h5>  
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0"> 
                  <ExpandableContent
                                    summaryText="O dióxido de carbono (CO₂) é um dos gases mais presentes em 
                                    nosso cotidiano — essencial para a vida, mas também protagonista das discussões 
                                    sobre mudanças climáticas. Compreender seu ciclo, usos e impactos é o primeiro 
                                    passo para transformar desafios em soluções de futuro."
                                  >
                                    <p>Do setor energético à indústria alimentícia, o CO₂ está em todos os lugares: refrigeração, soldagem, bebidas, agricultura controlada e até em tecnologias de captura e armazenamento que prometem redefinir a economia verde.</p>
                                    <p>Acompanhe os dados abaixo e descubra como o gás carbônico se comporta em volume, emissões e rentabilidade média nas principais cadeias produtivas.</p>
  </ExpandableContent>
                  <Row className="g-3 p-2">
                    
                    
                    <li style={{listStyleType: "none", display: "none"}}> 
                      <ul className="common-space pt-3">
                        <li> 
                          <ul> 
                            <li> 
                              <p className="mb-1">{t('Creation_Date')} </p><span>14/03/2024</span>
                            </li>
                            <br/>
                            <li> 
                              <p className="mb-1">Due Date</p><span>30 April, 2024</span>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <ul>
                            <li> 
                              <p className="mb-1">Priority</p>
                              <span className="badge badge-light-primary">{t('High')}</span>
                            </li>
                            <br/>
                            <li>
                              <p className="mb-1">{t('Status')}</p>
                              <span className="badge badge-light-success">{t('In_Progress')}</span>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p className="p-t-10 mb-2">Resource</p>
                          <div className="attachment-file common-flex">
                            <div className="common-flex align-items-center">
                              <img className="img-fluid" src={require("../../../../assets/icons/pdf.png")} alt="pdf" />
                              <div className="d-block"> 
                                <p className="mb-0">{t('Technical_Report')}</p>
                                <p className="c-o-light">678 KB</p>
                              </div>
                            </div>
                              <a href="../assets/pug/pages/template/text_file.pdf" download=""> 
                                <i className="fa fa-solid fa-download f-light"></i>
                              </a>
                          </div>
                        </li>
                      </ul>
                      </li>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

           
            <Row>
              <Col xs={12} xl={12} xxl={7} >
              <div className="card explore-card height-equal" style={{
                    minHeight: "247.594px"
                  , backgroundSize: "cover"
                  , backgroundRepeat: "no-repeat"
                  , backgroundImage: `url("/bg/bg-2.png")`
                  }}>
                  <div className="card-body">
                    <div className="row"> 
                      <div className="col-xxl-6 custom-rs-12">
                        <h5 className="mb-3">{t('AI_Prediction_Title')}</h5>
                        <p className="mb-3 f-light">{t('AI_Prediction_Description')}</p>
                        <div className="group-btn">
                          <a className="btn f-w-500 btn-primary" href="about:blank" onClick={(event) => event.preventDefault()}>{t('Explore')}</a>
                          
                        </div>
                        <ul className="decore">
                          <li className="dot-gradient dot-1"></li>
                          <li className="dot-gradient dot-2"></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} xl={12} xxl={5} >
                {RadialProgressWidgetData.map((item, i) => (
                    <RadialProgressWidget key={i} chartHeight={150} data={item} />
                 
                ))}
              </Col>
            </Row>

            {/*
            <Row>
              <Col xs={12} lg={12} xl={12}>
                <div className="card">
                  <div className="card-header">
                    <div className="header-top">
                      <h5 className="m-0">Projects Overview</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row g-3"> 
                      <div className="col-xxl-3 col-sm-6 box-col-6">
                        <div className="main-card-box bg-10-primary h-100">
                          <div className="p-20 main-cost-performance">
                            <h5>Project Cost Performance</h5>
                            <div className="common-space p-t-10">
                              <div>
                                <div className="cost-performance-wrapper">
                                  <div id="cost-performance" style={{minHeight: "84.6px"}}>
                                    </div></div></div></div></div>
                                </div>
                                
                      </div>
                              
                              <div className="col-xxl-3 col-sm-6 box-col-6">
                        <div className="main-card-box bg-10-secondary h-100">
                          <div className="p-20 common-space">
                            <div>
                              <h5>8.63</h5><span className="c-o-light">Highlights Rating</span>
                            </div>
                            <div className="project-right-icon bg-10-secondary"><i className="fa-solid fa-thumbs-up fa-fade txt-secondary"></i></div>
                          </div>
                          <div className="highlight-content">
                            <div className="common-space"><span className="f-w-500">Avg. Client Rate</span>
                              <div> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trending-up txt-success"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg><span className="f-w-500">7.8 / 10</span></div>
                            </div>
                            <div className="common-space"><span className="f-w-500">Avg. Marketplace Rate</span>
                              <div> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trending-down txt-danger"><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline></svg><span className="f-w-500">6.8 / 10</span></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-sm-6 box-col-6">
                        <div className="main-card-box bg-10-success h-100">
                          <div className="p-20 common-space">
                            <div>
                              <h5>56</h5><span className="c-o-light">Professionals Team</span>
                            </div>
                            <div className="project-right-icon bg-10-success"><i className="fa-solid fa-user fa-fade txt-success"></i></div>
                          </div>
                          <div className="p-20">
                            <h6 className="mb-sm-3 mb-2">View Team Members</h6>
                            <ul className="common-f-start">
                              <li data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Marley Ford"><img className="common-circle" src="../assets/images/dashboard-11/user/3.jpg" alt="user"/></li>
                              <li data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Sarah Wilson"><img className="common-circle" src="../assets/images/dashboard-11/user/7.jpg" alt="user"/></li>
                              <li data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Jessica Anderson"><img className="common-circle" src="../assets/images/dashboard-11/user/8.jpg" alt="user"/></li>
                              <li data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Ford Stoll"><img className="common-circle" src="../assets/images/dashboard-11/user/9.jpg" alt="user"/></li>
                              <li data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Davis Jone"><img className="common-circle" src="../assets/images/dashboard-11/user/1.jpg" alt="user"/></li>
                              <li data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="40+ More"> 
                                <div className="common-circle bg-lighter-secondary">40+</div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-sm-6 box-col-6">
                        <div className="main-card-box bg-10-warning h-100">
                          <div className="p-20 common-space">
                            <div>
                              <h5>153</h5><span className="c-o-light">Total Projects</span>
                            </div>
                            <div className="project-right-icon bg-10-warning"><i className="fa-solid fa-file-pen fa-fade txt-warning"></i></div>
                          </div>
                          <div className="project-list-card">
                            <div className="common-space"><span className="f-w-500">Pending</span><span>27</span></div>
                            <div className="common-space"> <span className="f-w-500">Progress</span><span>48</span></div>
                            <div className="common-space"><span className="f-w-500">Completed</span><span>78</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                      
                      
                    </div>
                </div>
              </Col>
            </Row>
            */}
            <Row>
              <Col xs={12} className='m-0 overall-card'>
                <Card>
                  <CardBody>
                          <UpcomingSchedule title={t('Activity_Schedule')} data={cronogramaAtividadesData} />
                  </CardBody>
                </Card>
              </Col>
          </Row>
          
            <Row>
            <Col xs={12} xl={12} xxl={8} >
                <Card>
                  <CardHeader className='card-no-border'>
                    <H6>{t('CO2_Emissions_Evolution')}</H6>
                  </CardHeader>
                  <br/>
                  <CardBody className='pt-0'>
                    <Row className='m-0 overall-card'>
                      <Col xs={12} className='p-0'>
                        <div className='chart-right'>
                          <Row>
                            <Col xs={12} lg={12} xl={12}>
                              <CardBody className='p-0'>
                                <UL attrUL={{ horizontal: true, className: 'd-flex balance-data' }}>
                                  <LI>
                                    <span className='circle bg-secondary' />
                                    <span className='f-light ms-1'>{t('Energy')}</span>
                                  </LI>
                                  <LI>
                                    <span className='circle bg-primary'> </span>
                                    <span className='f-light ms-1'>{t('Transport')}</span>
                                  </LI>
                                  <LI>
                                    <span className='circle bg-success'> </span>
                                    <span className='f-light ms-1'>{t('Industry')}</span>
                                  </LI>
                                </UL>
                                
                              </CardBody>
                            </Col>
                          </Row>
                         
                        </div>
                      </Col>
                    </Row>
                    <Row className='m-0 overall-card'>
                            <Col xs={12}>
                              <div className='current-sale-container order-container'>
                                  <ReactApexChart className='overview-wrapper' type='line' height={300} options={OptionsOverView.options} series={OptionsOverView.series} />
                                  <div className='back-bar-container'>
                                    <ReactApexChart type='bar' height={180} options={OptionsOverViewBarChart.options} series={OptionsOverViewBarChart.series} />
                                  </div>
                                </div>
                            </Col>
                    </Row>
                    <Row className='mt-3'>
                            <Col xs={12}>
                              <p className='f-light text-center mb-0' style={{ fontSize: '0.875rem' }}>
                                Os dados mostram estabilidade na emissão média da indústria e leve queda no setor energético, resultado direto do aumento do uso de biogás e energia solar.
                              </p>
                            </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              
              
              <Col xs={12} xl={12} xxl={4} > 
              <Row>
                <Col xs={12}>
                  
                    <div className="card small-widget"> 
                          <div className="card-body primary"> <span className="f-light">{t('CO2_Captured')}</span>
                            <div className="d-flex align-items-end gap-1">
                              <h4 className="counter" data-target="100">100</h4><span className="font-primary f-12 f-w-500"><i className="icon-arrow-up"></i><span>+50%</span></span>
                            </div>
                            <div className="bg-gradient"> 
                              <i className="fa fa-solid fa-arrow-down"></i>
                            </div>
                          </div>
                        </div>
                </Col>
                <Col xs={12}>
                  
                    <div className="card small-widget"> 
                          <div className="card-body danger"> <span className="f-light">{t('CO2_Reused')}</span>
                            <div className="d-flex align-items-end gap-1">
                              <h4 className="counter" data-target="100">100</h4><span className="font-primary f-12 f-w-500"><i className="icon-arrow-up"></i><span>+48%</span></span>
                            </div>
                            <div className="bg-gradient"> 
                              <i className="fa fa-solid fa-arrow-down"></i>
                            </div>
                          </div>
                        </div>
                </Col>
                <Col xs={12}>
                  
                    <div className="card small-widget"> 
                          <div className="card-body secondary"> <span className="f-light">{t('CO2_Emitted')}</span>
                            <div className="d-flex align-items-end gap-1">
                              <h4 className="counter" data-target="100">100</h4><span className="font-secondary f-12 f-w-500"><i className="icon-arrow-up"></i><span>+50%</span></span>
                            </div>
                            <div className="bg-gradient"> 
                              <i className="fa fa-solid fa-arrow-down"></i>
                            </div>
                          </div>
                        </div>
                </Col>
              </Row>
                    
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <CryptoAnnotations title="Evolução das Emissões de CO₂ por Valor (Jun - Dezembro 2024)" chartData={dadosEmissoesCO2} />
              </Col>
            </Row>
          </div>
        );

      case t('Process'):
        return (
          <div>
            <div className="wag-content-header">
              <h4 className="wag-content-title">{t('WAG_Process')}</h4>
              <p className="wag-content-description">O processo WAG envolve a alternância entre injeção de água e gás para maximizar a recuperação de petróleo</p>
            </div>
            <ul className="list-group wag-list-group">
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Injeção de água para manter pressão do reservatório
              </li>
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Injeção de gás para melhorar a mobilidade do petróleo
              </li>
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Monitoramento contínuo dos parâmetros de produção
              </li>
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Otimização baseada em dados de campo
              </li>
            </ul>
          </div>
        );

      case t('Applications_menu'):
        return (
          <div>
            <div className="wag-content-header">
              <h4 className="wag-content-title">{t('WAG_Applications')}</h4>
              <p className="wag-content-description">O WAG é aplicado em diversos tipos de reservatórios</p>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="card h-100 wag-item-card">
                  <div className="card-body">
                    <h6 className="card-title wag-item-title">
                      <i className="fa fa-arrow-right me-2 wag-item-icon"></i>
                      Reservatórios de petróleo com alta viscosidade
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="card h-100 wag-item-card">
                  <div className="card-body">
                    <h6 className="card-title wag-item-title">
                      <i className="fa fa-arrow-right me-2 wag-item-icon"></i>
                      Campos maduros com declínio de produção
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="card h-100 wag-item-card">
                  <div className="card-body">
                    <h6 className="card-title wag-item-title">
                      <i className="fa fa-arrow-right me-2 wag-item-icon"></i>
                      Reservatórios com heterogeneidade de permeabilidade
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="card h-100 wag-item-card">
                  <div className="card-body">
                    <h6 className="card-title wag-item-title">
                      <i className="fa fa-arrow-right me-2 wag-item-icon"></i>
                      Campos offshore e onshore
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case t('Benefits'):
        return (
          <div>
            <div className="wag-content-header">
              <h4 className="wag-content-title">{t('WAG_Benefits')}</h4>
              <p className="wag-content-description">Principais vantagens da técnica WAG</p>
            </div>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="card text-center h-100 wag-metric-card">
                  <div className="card-body">
                    <h3 className="wag-metric-value">15-25%</h3>
                    <h6 className="wag-metric-title">Aumento da Recuperação</h6>
                    <p className="wag-metric-description">Incremento na recuperação de petróleo</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="card text-center h-100 wag-metric-card">
                  <div className="card-body">
                    <h3 className="wag-metric-value">30%</h3>
                    <h6 className="wag-metric-title">Eficiência Energética</h6>
                    <p className="wag-metric-description">Redução no consumo de energia</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="card text-center h-100 wag-metric-card">
                  <div className="card-body">
                    <h3 className="wag-metric-value">40%</h3>
                    <h6 className="wag-metric-title">Custo-Benefício</h6>
                    <p className="wag-metric-description">Melhoria na relação custo-benefício</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case t('Files'):
        return (
          <div>
            <div className="wag-content-header">
              <h4 className="wag-content-title">{t('Documents_Attachments')}</h4>
              <p className="wag-content-description">Documentação técnica e relatórios relacionados ao WAG</p>
            </div>
            <ul className="list-group wag-list-group">
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Relatórios de campo
              </li>
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Análises de laboratório
              </li>
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Documentação técnica
              </li>
              <li className="list-group-item d-flex align-items-center wag-list-item">
                <i className="fa fa-check-circle me-2 wag-list-icon"></i>
                Certificações e licenças
              </li>
            </ul>
          </div>
        );

      case t('Activities'):
        return (
          <div>
            <div className="wag-content-header">
              <h4 className="wag-content-title">{t('Recent_Activities')}</h4>
              <p className="wag-content-description">Últimas atividades e atualizações do projeto</p>
            </div>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="card text-center h-100 wag-metric-card">
                  <div className="card-body">
                    <h3 className="wag-metric-value">12</h3>
                    <h6 className="wag-metric-title">Atividades Hoje</h6>
                    <p className="wag-metric-description">Tarefas concluídas</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="card text-center h-100 wag-metric-card">
                  <div className="card-body">
                    <h3 className="wag-metric-value">45</h3>
                    <h6 className="wag-metric-title">Esta Semana</h6>
                    <p className="wag-metric-description">Atividades realizadas</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="card text-center h-100 wag-metric-card">
                  <div className="card-body">
                    <h3 className="wag-metric-value">78%</h3>
                    <h6 className="wag-metric-title">Progresso</h6>
                    <p className="wag-metric-description">Conclusão do projeto</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return <div>{t('Content_Not_Found')}</div>;
    }
  };

  return (
    <Fragment>
      <Breadcrumbs mainTitle="WAG" parent="" title="" ShowBreadcrumb={false} />
      <Container fluid={true}>
        <Row className="wag-main-row">
          {/* Menu Lateral - Coluna Esquerda */}
          <Col xs={12} sm={12} md={12} lg={3} xl={2} className="wag-menu-col" id="menu-lateral">
            <Card className="wag-menu-card">
              <CardBody className="p-0">
                <Nav className="nav-pills wag-nav-pills">
                  
                  {menuOptions.map((option) => (
                    
                    <NavItem key={option.id}>
                        <div className="wag-nav-separator" aria-hidden="true" />
                      <NavLink
                        className={`nav-link ${activeTab === option.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(option.id)}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className={`fa fa-${option.icon} wag-nav-icon`}></i>
                        <span className="wag-nav-title">{option.title}</span>
                      </NavLink>
                      
                    </NavItem>
                    
                  ))}
                </Nav>
              </CardBody>
            </Card>
          </Col>

          {/* Área de Conteúdo - Coluna Direita */}
          <Col xs={12} sm={12} md={12} lg={12} xl={10} className="wag-content-col">
            <Card className="wag-content-card" style={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
              <CardBody>
                <TabContent activeTab={activeTab} className="wag-tab-content">
                  {menuOptions.map((option) => (
                    <TabPane key={option.id} tabId={option.id}>
                      {renderContent(option.title)}
                    </TabPane>
                  ))}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default WAGBassin;
